import {DataFetcher} from '@aboutyou/data-fetcher';
import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import {
  FilterFlyout,
  FilterFlyoutProps,
} from '../../../features/Filters/FilterFlyout/FilterFlyout';
import {FilterFlyoutError} from '../../../features/Filters/FilterFlyout/FilterFlyoutError';
import {FilterFlyoutLoading} from '../../../features/Filters/FilterFlyout/FilterFlyoutLoading';
import {FlyoutFilters} from '../../../features/Filters/FilterFlyout/FlyoutFilters';
import {useSearchPageFiltersSection} from '../hooks/useSearchPageBulkSection';

export const SearchStreamFilterFlyout: React.FC<
  Omit<FilterFlyoutProps, 'FilterContent'>
> = props => {
  return <FilterFlyout FilterContent={FilterContent} {...props} />;
};

const FilterContent: FilterFlyoutProps['FilterContent'] = props => {
  const {t} = useTranslation();

  const submitButtonLabel = t('Show results');

  return (
    <DataFetcher
      request={useSearchPageFiltersSection()}
      Error={FilterFlyoutError}
      Loading={FilterFlyoutLoading}
      viewProps={{...props, submitButtonLabel}}
      View={({filters, submitButtonLabel, ...otherProps}) => {
        return (
          <FlyoutFilters
            availableFilters={filters}
            data-testid="filterFlyoutSections"
            productCount={0}
            submitButtonLabel={submitButtonLabel}
            {...otherProps}
          />
        );
      }}
    />
  );
};
